import React, { Component } from "react";

export default class Taskbar extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="task-bar">
        <div className="task-bar-back" onClick={this.props.back}>
          <i className="fas fa-chevron-left" />
        </div>
        <div className="task-bar-title">{this.props.title}</div>
        <div className="task-bar-options">
          <i className="fas fa-ellipsis-h" />
        </div>
      </div>
    );
  }
}
